import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=c1657b30"
import script from "./FeedbackCard.vue?vue&type=script&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports